import React, { useState } from 'react';
import { useSecurity } from './components/home/Security';
import Layout from './components/home/Layout';
import { Switch, Route, Redirect, HashRouter as Router } from 'react-router-dom';
import Routes from './components/home/Routes'
import Breadcrumb from './components/home/Breadcrumb'
import './scss/App.scss';
import { useEffect } from 'react';
import { authProvider } from './services/Security';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';

export enum LoggedIn {
    True,
    False,
    Null
}

function RoutesWithCrumbs({ district, operator, isLoggedIn }) {
    const { authenticationState } = useSecurity();

    return (
        <Switch>
            {Routes.map(({ path, name, Component }, key) => (
                <Route
                    exact
                    path={path}
                    key={key}
                    render={props => {
                        if(isLoggedIn === LoggedIn.True || authenticationState === "Authenticated" || name === "Reset"){
                            const crumbs = Routes
                                .filter(({ path }) => props.match.path.includes(path))
                                .map(({ path, ...rest }) => ({
                                    path: Object.keys(props.match.params).length
                                        ? Object.keys(props.match.params).reduce(
                                            (path, param) =>
                                            path.replace(`:${param}`, props.match.params[param]),
                                            path
                                        )
                                        : path,
                                    ...rest
                                }));
                            return (
                                <div className="p-8">
                                    <Breadcrumb crumbs={crumbs} />
                                    <Component district={district} operator={operator} />
                                </div>
                            );
                        }
                        if(isLoggedIn === LoggedIn.False){
                            return (<Redirect to={{ pathname: '/' }} />);
                        }
                        return null;
                    }}
                />
            ))}
        </Switch>
    )
}

export default function App() {
    const [district, setDistrict] = useState<any>();
    const [operator, setOperator] = useState<any>();
    const [isLoggedIn, setIsLoggedIn] = useState<LoggedIn>(LoggedIn.Null)
    useEffect(() => {
        var isLogged = authProvider.checkLogin()
        setIsLoggedIn(isLogged ? LoggedIn.True : LoggedIn.False)
    }, [])

    const theme = createTheme({
        palette: {
          primary: {
            main: green[500],
          },
          secondary: {
            main: red[500],
          },
        },
      });

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <div className="App">
                    <Layout setDistrict={setDistrict} district={district} setOperator={setOperator} operator={operator} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}>
                        <RoutesWithCrumbs district={district} operator={operator} isLoggedIn={isLoggedIn} />
                    </Layout>
                </div>
            </Router>
        </ThemeProvider>
    );
}